export enum RecaptchaActionType {
  SANITY_FILM_CONTENT = 'SANITY_FILM_CONTENT',
  MUSIC_API_SONG_EVENT = 'songEvent',
}
